function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/notification/notification
 */

/* globals window */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * The Notification plugin.
 *
 * This plugin sends a few types of notifications: `success`, `info` and `warning`. The notifications need to be
 * handled and displayed by a plugin responsible for showing the UI of the notifications. Using this plugin for dispatching
 * notifications makes it possible to switch the notifications UI.
 *
 * Note that every unhandled and not stopped `warning` notification will be displayed as a system alert.
 * See {@link module:ui/notification/notification~Notification#showWarning}.
 *
 * @extends module:core/plugin~Plugin
 */

var Notification = /*#__PURE__*/function (_Plugin) {
  _inherits(Notification, _Plugin);

  var _super = _createSuper(Notification);

  function Notification() {
    _classCallCheck(this, Notification);

    return _super.apply(this, arguments);
  }

  _createClass(Notification, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      // Each unhandled and not stopped `show:warning` event is displayed as a system alert.
      this.on('show:warning', function (evt, data) {
        window.alert(data.message); // eslint-disable-line no-alert
      }, {
        priority: 'lowest'
      });
    }
    /**
     * Shows a success notification.
     *
     * By default, it fires the {@link #event:show:success `show:success` event} with the given `data`. The event namespace can be extended
     * using the `data.namespace` option. For example:
     *
     * 		showSuccess( 'Image is uploaded.', {
     * 			namespace: 'upload:image'
     * 		} );
     *
     * will fire the `show:success:upload:image` event.
     *
     * You can provide the title of the notification:
     *
     *		showSuccess( 'Image is uploaded.', {
     *			title: 'Image upload success'
     *		} );
     *
     * @param {String} message The content of the notification.
     * @param {Object} [data={}] Additional data.
     * @param {String} [data.namespace] Additional event namespace.
     * @param {String} [data.title] The title of the notification.
     */

  }, {
    key: "showSuccess",
    value: function showSuccess(message) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._showNotification({
        message: message,
        type: 'success',
        namespace: data.namespace,
        title: data.title
      });
    }
    /**
     * Shows an information notification.
     *
     * By default, it fires the {@link #event:show:info `show:info` event} with the given `data`. The event namespace can be extended
     * using the `data.namespace` option. For example:
     *
     * 		showInfo( 'Editor is offline.', {
     * 			namespace: 'editor:status'
     * 		} );
     *
     * will fire the `show:info:editor:status` event.
     *
     * You can provide the title of the notification:
     *
     *		showInfo( 'Editor is offline.', {
     *			title: 'Network information'
     *		} );
     *
     * @param {String} message The content of the notification.
     * @param {Object} [data={}] Additional data.
     * @param {String} [data.namespace] Additional event namespace.
     * @param {String} [data.title] The title of the notification.
     */

  }, {
    key: "showInfo",
    value: function showInfo(message) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._showNotification({
        message: message,
        type: 'info',
        namespace: data.namespace,
        title: data.title
      });
    }
    /**
     * Shows a warning notification.
     *
     * By default, it fires the {@link #event:show:warning `show:warning` event}
     * with the given `data`. The event namespace can be extended using the `data.namespace` option. For example:
     *
     * 		showWarning( 'Image upload error.', {
     * 			namespace: 'upload:image'
     * 		} );
     *
     * will fire the `show:warning:upload:image` event.
     *
     * You can provide the title of the notification:
     *
     *		showWarning( 'Image upload error.', {
     *			title: 'Upload failed'
     *		} );
     *
     * Note that each unhandled and not stopped `warning` notification will be displayed as a system alert.
     * The plugin responsible for displaying warnings should `stop()` the event to prevent displaying it as an alert:
     *
     * 		notifications.on( 'show:warning', ( evt, data ) => {
     * 			// Do something with the data.
     *
     * 			// Stop this event to prevent displaying it as an alert.
     * 			evt.stop();
     * 		} );
     *
     * You can attach many listeners to the same event and `stop()` this event in a listener with a low priority:
     *
     * 		notifications.on( 'show:warning', ( evt, data ) => {
     * 			// Show the warning in the UI, but do not stop it.
     * 		} );
     *
     * 		notifications.on( 'show:warning', ( evt, data ) => {
     * 			// Log the warning to some error tracker.
     *
     * 			// Stop this event to prevent displaying it as an alert.
     * 			evt.stop();
     * 		}, { priority: 'low' } );
     *
     * @param {String} message The content of the notification.
     * @param {Object} [data={}] Additional data.
     * @param {String} [data.namespace] Additional event namespace.
     * @param {String} [data.title] The title of the notification.
     */

  }, {
    key: "showWarning",
    value: function showWarning(message) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._showNotification({
        message: message,
        type: 'warning',
        namespace: data.namespace,
        title: data.title
      });
    }
    /**
     * Fires the `show` event with the specified type, namespace and message.
     *
     * @private
     * @param {Object} data The message data.
     * @param {String} data.message The content of the notification.
     * @param {'success'|'info'|'warning'} data.type The type of the message.
     * @param {String} [data.namespace] Additional event namespace.
     * @param {String} [data.title=''] The title of the notification.
     */

  }, {
    key: "_showNotification",
    value: function _showNotification(data) {
      var event = "show:".concat(data.type) + (data.namespace ? ":".concat(data.namespace) : '');
      this.fire(event, {
        message: data.message,
        type: data.type,
        title: data.title || ''
      });
    }
    /**
     * Fired when one of the `showSuccess()`, `showInfo()`, `showWarning()` methods is called.
     *
     * @event show
     * @param {Object} data The notification data.
     * @param {String} data.message The content of the notification.
     * @param {String} data.title The title of the notification.
     * @param {'success'|'info'|'warning'} data.type The type of the notification.
     */

    /**
     * Fired when the `showSuccess()` method is called.
     *
     * @event show:success
     * @param {Object} data The notification data.
     * @param {String} data.message The content of the notification.
     * @param {String} data.title The title of the notification.
     * @param {'success'} data.type The type of the notification.
     */

    /**
     * Fired when the `showInfo()` method is called.
     *
     * @event show:info
     * @param {Object} data The notification data.
     * @param {String} data.message The content of the notification.
     * @param {String} data.title The title of the notification.
     * @param {'info'} data.type The type of the notification.
     */

    /**
     * Fired when the `showWarning()` method is called.
     *
     * When this event is not handled or stopped by `event.stop()`, the `data.message` of this event will
     * be automatically displayed as a system alert.
     *
     * @event show:warning
     * @param {Object} data The notification data.
     * @param {String} data.message The content of the notification.
     * @param {String} data.title The title of the notification.
     * @param {'warning'} data.type The type of the notification.
     */

  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Notification';
    }
  }]);

  return Notification;
}(Plugin);

export { Notification as default };